import {ApiHelper, axiosInstance } from '../utils/ApiHelper'

export function getTotals(filters) {
  return (dispatch, getState) => {
    dispatch({type: 'GET_TOTALS_REQUEST'})
    // const { filters } = getState().trips
    return ApiHelper.getTotals(filters)
      .then( json => dispatch({type: 'GET_TOTALS_SUCCESS', user: {totals: json.data} }) )

  }
}


export function updateRange(value) {
  return (dispatch) => {
    // dispatch({type: 'APPLY_DATE_FILTER', dateRange: value})
    const filters = toRangeParams(value)
    dispatch(getTotals(filters))
  }
}



// TODO same as in /work-hours

export const toRangeParams = (range) => {
  if (range.length<2) return {
    start_day: null,
    start_month: null,
    start_year: null,

    end_day: null,
    end_month: null,
    end_year: null,
  }

  const start = range[0]
  const end = range[1]
  return {
    start_day: start.format("D"),
    start_month: start.format("M"),
    start_year: start.format("YYYY"),

    end_day: end.format("D"),
    end_month: end.format("M"),
    end_year: end.format("YYYY"),
  }
}



// WEBPACK FOOTER //
// ./src/home/actions.js